// extracted by css-extract-rspack-plugin
export default {"page":"TermsV2-module__page"};